import { render, staticRenderFns } from "./OrgChartNode.vue?vue&type=template&id=04d5d670&scoped=true&"
import script from "./OrgChartNode.vue?vue&type=script&lang=js&"
export * from "./OrgChartNode.vue?vue&type=script&lang=js&"
import style0 from "./OrgChartNode.vue?vue&type=style&index=0&id=04d5d670&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d5d670",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
